import React, {forwardRef, KeyboardEvent, useCallback, useEffect, useImperativeHandle, useRef, useState} from 'react'

import VScroll from "../../../scrolling/custom-v-scroll/v-scroll"
import UserIcon from "../../../../gd-ui/icon/user/user"
import {ENTITY_SELECTOR_MENU_HEIGHT, ENTITY_SELECTOR_SEARCH_HEIGHT} from "../../selector"
import {MentionOption} from "../../../editor/plugins/mentions/option"
import {findDOMNode} from "react-dom";

type Props = {
    style?              : any
    search              : string

    options             : MentionOption[]

    onEntitySelected    : {(entity:MentionOption):void}
    onTab               : {():void}
}

const debug = false
// const debug = "EntitySelectorUsersList"

const EntitySelectorUsersList = forwardRef((props:Props, ref) => {
    const [currentCursorKey, setCurrentCursorKey] = useState<number>(0)
    const scrollRef = useRef<any>()

    const onKeyDown = useCallback((event:KeyboardEvent) => {
        debug && console.log(debug, 'onKeyDown', currentCursorKey, event)

        const selectOptions = props.options

        let newValue
        switch(event.code) {
            case 'Tab':
                event.preventDefault()
                props.onTab()
                break

            case 'ArrowUp':
                if (_.isNil(currentCursorKey)) {
                    newValue = 0
                } else {
                    newValue = currentCursorKey - 1
                    if (newValue < 0) newValue = 0
                }

                setCurrentCursorKey(newValue)
                break

            case 'ArrowDown':
                if (_.isNil(currentCursorKey)) {
                    newValue = 0
                } else {
                    newValue = currentCursorKey + 1
                    if (newValue > selectOptions.length - 1) newValue = selectOptions.length - 1;
                }

                setCurrentCursorKey(newValue)
                break

            case 'Enter':
                event.preventDefault()
                event.stopPropagation()

                if (!_.isNil(currentCursorKey)) {
                    const curOption = selectOptions[currentCursorKey]
                    if (curOption) props.onEntitySelected(curOption)
                }
                break
        }
    },[currentCursorKey, props.options])

    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    useImperativeHandle(ref, () => ({
        onKeyDown,
    }))

    useEffect(()=>{
        debug && console.log(debug, 'useEffect', currentCursorKey)

        if (scrollRef.current) {
            const node = findDOMNode(scrollRef.current)
            if (node) {
                const element: any = (node as Element)?.querySelector("#option-{0}".f(currentCursorKey))
                if (element) scrollRef.current?.setScrollTop(element.offsetTop + element.clientHeight/2,true,250)
            }
        }
    }, [currentCursorKey])

    const styles = {
        height: `calc(100% - ${ENTITY_SELECTOR_MENU_HEIGHT + ENTITY_SELECTOR_SEARCH_HEIGHT}px)`
    }

    debug && console.log(debug, 'render', currentCursorKey, props)

    return (
        <div className="entity-selector-list" style={styles} onKeyDown={onKeyDown}>
            <VScroll ref={scrollRef} minDragHeight={20}>
                {_.map(props.options, (option:MentionOption,key:number)=>{
                    const classes = Classes("entity-item flex-row-left-center h-36 p-l-20 p-r-20 txt-truncate", {
                        'is-highlighted': key === currentCursorKey
                    })

                    return (
                        <div key        = {option.id}
                             id         = {"option-{0}".f(key)}
                             className  = {classes}
                             onClick    = {() => props.onEntitySelected(option)}>
                            <UserIcon className="m-r-5" size="22" userId={option.id}/>
                            <div className="ui5-txt-default txt-truncate">{option.name}</div>
                        </div>
                    )
                })}
            </VScroll>
        </div>
    )
})

export default EntitySelectorUsersList
